// import "../App.typography-rhythm-refined.css";
import React from "react";
import { Routes, Route } from "react-router-dom";
import { useSector } from "./SectorContext";
import MainMenu from "./MainMenu";
import HomePage from "./HomePage";
import ProjectPage from "./ProjectPage";
import ContactPage from "./ContactPage";
import AboutPage2 from "./AboutPage2"

function AppContent() {
  const { activeSector } = useSector();

  return (
    <div className={`site-shell ${activeSector.colorClass}`}>
      <div className="site-texture" aria-hidden="true" />

      <MainMenu />

      <div className="app-container">
        <Routes>
          <Route path="/" element={<HomePage />} />
          {/* <Route path="/about" element={<AboutPage />} /> */}
           <Route path="/about" element={<AboutPage2 />} />
          <Route path="/project" element={<ProjectPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </div>
    </div>
  );
}

export default AppContent;